import styled from 'styled-components';
import { FormField } from '@hqo/react-components-library/dist/atoms/form-field';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const VisitorBlockContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  width: 100%;
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
`;

export const Title = styled.div`
  font: 600 14px / normal ${({ theme }) => theme.fonts.join()};
  color: ${({ theme }) => theme.colors.palette.systemBlack};
`;

export const StyledFormField = styled(FormField)`
  width: 100%;
  margin-bottom: 10px;

  span {
    padding: 2px 0 0 0;
  }
`;

export const DeleteGuestIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.palette.systemGreyDark};
  cursor: pointer;
  margin-left: 10px;
`;
